var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-divider',{staticClass:"my-2"}),_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.label))]),_c('v-divider',{staticClass:"my-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }